import React, { useState } from 'react';
import { FlaskConical, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { useDemoMode } from '../contexts/DemoModeContext';
import { toast } from 'sonner';

/**
 * DemoModeBanner — sitewide banner shown when org is in Demo Mode.
 * Overrides normal setup banners with clear messaging and exit CTA.
 */
const DemoModeBanner = () => {
  const { active, loading, exit } = useDemoMode();
  const [exiting, setExiting] = useState(false);

  if (!active) return null;

  const handleExit = async () => {
    setExiting(true);
    try {
      await exit();
      toast.success('Demo Mode deactivated. Demo data removed.');
      // Reload to refresh Calendar tab visibility + all pages
      setTimeout(() => window.location.reload(), 300);
    } catch (e) {
      toast.error('Failed to exit Demo Mode. Please try again.');
      setExiting(false);
    }
  };

  return (
    <div
      className="mb-4 p-3 bg-amber-50 dark:bg-amber-900/20 border-2 border-amber-300 dark:border-amber-700 rounded-lg flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3"
      data-testid="demo-mode-banner"
    >
      <div className="flex items-start gap-3">
        <FlaskConical className="w-5 h-5 text-amber-600 dark:text-amber-400 mt-0.5 flex-shrink-0" />
        <div>
          <p className="font-semibold text-amber-900 dark:text-amber-100 text-sm">
            Demo Mode Active — using mock channel + preview calendar
          </p>
          <p className="text-xs text-amber-700 dark:text-amber-300 mt-0.5">
            Exit Demo Mode to connect your real providers.
          </p>
        </div>
      </div>
      <Button
        variant="outline"
        size="sm"
        className="border-amber-400 text-amber-800 hover:bg-amber-100 dark:border-amber-600 dark:text-amber-100 dark:hover:bg-amber-900/40 flex-shrink-0"
        onClick={handleExit}
        disabled={exiting || loading}
        data-testid="demo-mode-exit-banner-btn"
      >
        {exiting ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
        Exit Demo Mode
      </Button>
    </div>
  );
};

export default DemoModeBanner;
